document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-desktop-builder-gallery]').forEach((media) => {
    const image = media.querySelector('[data-builder-preview-image]');
    if (!image) return;
    let slides = [], index = 0, label = '', opener = null, overflow = '';
    const prefetched = new Map();
    let preloadQueue = [], preloadActive = 0;
    const button = (text, name, className) => {
      const node = document.createElement('button');
      node.type = 'button'; node.textContent = text; node.className = className;
      node.setAttribute('aria-label', name); return node;
    };
    const open = button('', 'View larger product image', 'af-builder-gallery-open');
    const counter = document.createElement('span');
    counter.className = 'af-builder-gallery-counter'; counter.setAttribute('aria-live', 'polite');
    media.append(open, counter);
    const dialog = document.createElement('dialog');
    dialog.className = 'af-builder-gallery-dialog';
    dialog.setAttribute('aria-label', 'Larger product images');
    const close = button('×', 'Close larger image', 'af-builder-gallery-close');
    const zoomPrev = button('←', 'Previous product image', 'af-builder-gallery-arrow is-previous');
    const zoomNext = button('→', 'Next product image', 'af-builder-gallery-arrow is-next');
    const zoomImage = document.createElement('img');
    const zoomCount = document.createElement('p'); zoomCount.className = 'af-builder-gallery-zoom-count'; zoomCount.setAttribute('aria-live', 'polite');
    dialog.append(close, zoomPrev, zoomImage, zoomNext, zoomCount);
    document.body.append(dialog);
    function pumpPreloads() {
      if (!dialog.open || mobile.matches) return;
      while (preloadActive < 2 && preloadQueue.length) {
        const src = preloadQueue.shift();
        if (prefetched.has(src)) continue;
        const preload = new Image();
        preload.decoding = 'async';
        preload.fetchPriority = src === slides[(index + 1) % slides.length] ? 'auto' : 'low';
        prefetched.set(src, preload);
        preloadActive++;
        let settled = false;
        const finish = (success) => {
          if (settled) return;
          settled = true;
          preload.onload = null; preload.onerror = null;
          if (!success && prefetched.get(src) === preload) prefetched.delete(src);
          preloadActive--;
          pumpPreloads();
        };
        preload.onload = () => {
          if (typeof preload.decode === 'function') preload.decode().catch(() => {}).then(() => finish(true));
          else finish(true);
        };
        preload.onerror = () => finish(false);
        preload.src = src;
      }
    }
    function queuePreloads() {
      // Only the opened product gallery; never preload other products on page load.
      preloadQueue = [];
      for (let offset = 1; offset < slides.length; offset++) {
        const src = slides[(index + offset) % slides.length];
        if (!prefetched.has(src)) preloadQueue.push(src);
      }
      pumpPreloads();
    }
    function sourceKey(src) {
      try { const url = new URL(src, location.href); url.searchParams.delete('width'); return url.href; } catch { return src; }
    }
    function render() {
      if (!slides.length || mobile.matches) return;
      media.dataset.desktopGalleryIndex = String(index);
      image.src = slides[index]; image.alt = `${label} — image ${index + 1}`;
      counter.textContent = `${index + 1} / ${slides.length}`;
      open.setAttribute('aria-label', `View larger image of ${label}, image ${index + 1}`);
      for (const node of [zoomPrev, zoomNext]) node.hidden = slides.length < 2;
      if (dialog.open) {
        // Use the original gallery URL; do not lower the zoom source resolution.
        zoomImage.src = slides[index]; zoomImage.alt = image.alt;
        zoomCount.textContent = `${label} · ${index + 1} / ${slides.length}`;
        queuePreloads();
      }
    }
    function setGallery(gallery) {
      preloadQueue = [];
      prefetched.clear();
      const seen = new Map();
      for (const src of gallery.images || []) {
        if (src) seen.set(sourceKey(src), src);
      }
      slides = [...seen.values()]; index = 0; label = gallery.label || 'Product image'; render();
    }
    function move(delta) { if (slides.length) { index = (index + delta + slides.length) % slides.length; render(); } }
    zoomPrev.addEventListener('click', () => move(-1)); zoomNext.addEventListener('click', () => move(1));
    open.addEventListener('click', () => {
      if (!slides.length || dialog.open || mobile.matches) return;
      opener = document.activeElement; overflow = document.documentElement.style.overflow;
      dialog.showModal(); document.documentElement.style.overflow = 'hidden'; render(); close.focus({preventScroll:true});
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
    });
    dialog.addEventListener('close', () => { preloadQueue = []; document.documentElement.style.overflow = overflow; opener?.focus({preventScroll:true}); });
    const mobile = window.matchMedia('(max-width: 749px)');
    mobile.addEventListener('change', () => { if (mobile.matches && dialog.open) dialog.close(); if (!mobile.matches) render(); });
    media.addEventListener('builder:preview-gallery', (event) => setGallery(event.detail));
    let initial;
    try { initial = JSON.parse(media.dataset.desktopGallery || 'null'); } catch { /* Use the existing preview if no catalog is available. */ }
    setGallery(initial || {label:image.alt, images:[image.src]});
  });
});
